export default __webpack_public_path__ + "static/media/purpgem.84d3d941.jpg";